<template>
     <div class="carBox">
        <el-card class="box-card" style="width: 280px;margin-right: 20px; position: relative;">
            <el-select v-model="upData.recognition_type" placeholder="请选择" style="width: 100%;margin-bottom: 14px;">
                <el-option label="成都翰矽GJY-VIII（一体机）" value="1"></el-option>
                <el-option label="成都翰矽GJY-VII（电脑版）" value="9"></el-option>
                <el-option label="成都翰矽GJY-VII（四参数）" value="10"></el-option>
                <el-option label="成都翰矽GJY-VIII（二维码）" value="13"></el-option>
                <!-- <el-option label="中大华瑞" value="2"></el-option> -->
                <el-option label="成都鼎盛华瑞" value="3"></el-option>
                <el-option label="长委" value="4"></el-option>
                <el-option label="天津赛智" value="5"></el-option>
                <el-option label="杭州弘升笔记本" value="6"></el-option>
                <el-option label="杭州弘升一体机" value="7"></el-option>
                <el-option label="中成华瑞" value="8"></el-option>
                <el-option label="成都西江科技" value="11"></el-option>
                <el-option label="长委IX代" value="12"></el-option>
                <el-option label="成都鸿思达" value="14"></el-option>
                <el-option label="杭州长杰" value="15"></el-option>
            </el-select>

            <div class="radioBox" style="margin-bottom: 14px;">
                <el-radio v-model="file_type" label="1" style="margin-left: 0;padding: 12px 12px 0 10px;" border>上传文件</el-radio>
                <el-radio v-model="file_type" label="2" style="margin-left: 0;padding: 12px 13px 0 10px;" border>扫描文件</el-radio>
            </div>
            
            <el-upload class="upload-demo" drag ref="upload" name="upFile" v-if="file_type==1"
                :action="uploadAction"
                :on-success="handleUploadSuccess"
                :before-upload="beforeUpload"
                :data="upData"
                :file-list="fileList">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或&nbsp;<em>点击上传</em></div>
            </el-upload>
            <div style="width: 100%;" v-if="data_type==9">
                <template v-for="msg in msgList">
                    <el-alert :title="msg" type="error" :closable="false" :key="msg" style="margin-top: 10px"></el-alert>
                </template>
            </div>
            <div class="btnBox" v-if="file_type==2 && data_type==0">
                <el-button type="primary" @click="takePictures">第一步：扫描文件</el-button>
            </div>
            <el-image :v-if="file_type==2 && data_type==0" style="width: 100%; height: 320px;margin-top: 14px;border-radius: 8px;" :src="base64" v-for="base64 in fileListBase64" :key="base64" :preview-src-list="fileListBase64"></el-image>
            <div class="btnBox" v-if="data_type==0 && uuidList.length>0">
                <el-button type="primary" @click="mergeToPdf">第二步：上传文件</el-button>
            </div>
            <div class="btnBox" v-if="data_type==1">
                <el-button type="primary" @click="saveData(0, 2)">暂存报告</el-button>
                <el-button type="success" @click="saveData(0, 1)">保存报告</el-button>
            </div>
            <!-- <el-button type="primary" @click="testImp" style="position: absolute; bottom: 500px;left: 24px;margin-left: 10px">测试数据</el-button> -->
            <el-button type="primary" @click="ocrLogList(2)" style="position: absolute; bottom: 20px;left: 24px">暂存记录</el-button>
            <el-button type="success" @click="ocrLogList(1)" style="position: absolute; bottom: 20px;left: 140px">识别记录</el-button>
        </el-card>
        <div style="width: calc(100% - 300px); height: 100%">
            <el-row style="width: 100%">
                <el-col :span="24">
                    <el-card class="box-card">
                        <div slot="header" class="clearfix" style="text-align: center">
                            <span style="font-size: 22px;font-weight: bold">{{report.work_type}}记录表</span>
                        </div>
                        <div class="el-table el-table--fit el-table--striped el-table--border el-table--enable-row-hover el-table--enable-row-transition">
                            <div class="el-table__body-wrapper is-scrolling-none">
                                <table class="el-table__body" width="100%" cellspacing="0" cellpadding="0" border="0">
                                    <tbody>
                                        <tr class="el-table-row el-table__row--striped">
                                            <td class="el-table__cell is-right" style="width: 140px">
                                                <div class="cell"><span>设备编号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.device_code"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right" style="width: 130px">
                                                <div class="cell"><span>通道号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.channel_no"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right" style="width: 150px">
                                                <div class="cell"><span>开始时间：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.begin_time"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right" style="width: 140px">
                                                <div class="cell"><span>结束时间：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.end_time"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>单元：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.unit_code" readonly></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>作业方式：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.work_type" @change="workTypeChange"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>孔号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.hole_code"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>孔序：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.hole_order" readonly></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.segment_no"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段长(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.segment_length"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段顶(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.segment_top"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>段底(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.segment_bottom"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>桩号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.pile_no"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>抬动孔号：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.lift_hole_no"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>孔口高程(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.hole_height"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>排序：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.order_index"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>水灰比：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.water_ash"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>砂灰比：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.sand_ash"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>压力设定(Mpa)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.pressure_set"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>水泥比重(g/cm3)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.water_mud_proportion"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>砂比重(g/cm3)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.sand_proportion"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>循环方式：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.circle_type"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>涌水压力(Mpa)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.water_pressure"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>地下水位(m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.groundwater_level"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>注浆量(L)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.grout_volume"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>累计注灰量(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.ash_volume"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>单位注灰量(kg/m)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.ash_volume_unit"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>砂量(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.sand_volume"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>余浆量(L)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.grout_volume_throw"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>弃灰量(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.ash_volume_throw"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>管容(L)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.piping_volume"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>管道占灰量(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.piping_ash_volume"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>外加剂1(Kg)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.material1_total"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>外加剂2(Kg):</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.material2_total"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>防伪特征码：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.security_code"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>纯灌时间(秒)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.grout_duration"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr class="el-table-row el-table__row--striped" v-if="report.work_type_int ==2 || report.work_type_int ==3">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>透水率(Lu)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.permeable_rate"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>防伪特征码：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.security_code"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>纯灌时间(秒)：</span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell">
                                                    <el-input v-model="report.grout_duration"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span></span></div>
                                            </td>
                                            <td class="el-table__cell">
                                                <div class="cell"><span></span></div>
                                            </td>
                                        </tr>
                                        <tr class="el-table__row">
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>施工单位：</span></div>
                                            </td>
                                            <td class="el-table__cell" colspan="3">
                                                <div class="cell">
                                                    <el-input v-model="report.construction_unit"></el-input>
                                                </div>
                                            </td>
                                            <td class="el-table__cell is-right">
                                                <div class="cell"><span>监测单位：</span></div>
                                            </td>
                                            <td class="el-table__cell" colspan="3">
                                                <div class="cell">
                                                    <el-input v-model="report.monitor_unit"></el-input>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
            <el-row style="width: 100%; height: 455px; margin-top: 20px;margin-left: 0;margin-right: 0;" :gutter="20">
                <el-col :span="24" style="padding-left: 0;height:100%">
                    <el-card class="box-card" style="height: 100%">
                        <div slot="header" class="clearfix">
                            <span>采样数据</span>
                            <el-button type="primary" plain size="mini" @click="addRow" style="margin-left:20px;position: relative;top: -2px">新增</el-button>
                        </div>
                        <el-table :data="samplingList" border stripe height="370">
                            <el-table-column label="时间">
                                <template slot-scope="scope">
                                    <el-input name="sampling_time_str" v-model="scope.row.sampling_time_str"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="flow" label="流量(L/Min)">
                                <template slot-scope="scope">
                                    <el-input name="flow" v-model="scope.row.flow"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="flow_in" label="进浆(L/Min)">
                                <template slot-scope="scope">
                                    <el-input name="flow_in" v-model="scope.row.flow_in"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="flow_out" label="回浆(L/Min)">
                                <template slot-scope="scope">
                                    <el-input name="flow_out" v-model="scope.row.flow_out"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pressure" label="压力(Mpa)">
                                <template slot-scope="scope">
                                    <el-input name="pressure" v-model="scope.row.pressure"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="pressure" label="峰压力(Mpa)">
                                <template slot-scope="scope">
                                    <el-input name="pressure_max" v-model="scope.row.pressure_max"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="density" label="密度(g/cm3)">
                                <template slot-scope="scope">
                                    <el-input name="density" v-model="scope.row.density"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="grout_volume" label="注浆量(L)" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                <template slot-scope="scope">
                                    <el-input name="grout_volume" v-model="scope.row.grout_volume"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="ash_volume" label="注灰量(kg)" v-if="report.work_type_int ==1 || report.work_type_int ==4 || report.work_type_int ==5">
                                <template slot-scope="scope">
                                    <el-input name="ash_volume" v-model="scope.row.ash_volume"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="permeable_rate" label="透水率(Lu)" v-if="report.work_type_int ==2 || report.work_type_int ==3">
                                <template slot-scope="scope">
                                    <el-input name="permeable_rate" v-model="scope.row.permeable_rate"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="lift" label="抬动(um)">
                                <template slot-scope="scope">
                                    <el-input name="lift" v-model="scope.row.lift"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="备注">
                                <template slot-scope="scope">
                                    <el-input name="remark" v-model="scope.row.remark"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="remark" label="操作" width="145">
                                <template slot-scope="scope">
                                    <el-button type="danger" plain size="mini" @click="downRow(scope.$index)">删除</el-button>
                                    <el-button type="primary" plain size="mini" @click="insertRow(scope.$index)">插入</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <OcrLogList
            width="1200px"
            :save_type="save_type"
            :title="ocr_title"
            :isshow="ocrlogshow"
            @on-select-log="selectOcrLog"
            @on-close="closeOcrLogDialog">
        </OcrLogList>
    </div>
</template>

<script>
import editutil from '@/libs/editutil'
import { ocrRecognitionPDF, uploadBase64File, ocrSaveReport, ocrInfo } from "@/api/workreport";
import { takePictures, mergeToPdf } from "@/api/cameraservice";
import OcrLogList from "../ocrlog/list"

export default {
    name: 'workreportOcrImport',
    mixins: [editutil],
    components: { OcrLogList },
    data() {
        return {
            hole_id: 0,
            uploadAction: "/api/admin/workreportocr/ocrRecognitionPDF",
            fileList: [],
            data_type: 0,
            msgList: [],
            report: {
                work_type_int: 1
            },
            samplingList: [],
            filePath: '',
            fileName: '',
            upData: {
                recognition_type: '1'
            },
            ocrlogshow: false,
            ocr_log_id: 0,
            file_type: '1',
            uuidList: [],
            fileListBase64: [],
            ocr_title: '',
            save_type: 1,
        };
    },
    methods: {
        handleUploadSuccess(res, file){
            this.resetData()
            if(res.code ==1){
                this.$msgs("请预览该报告数据");
                this.report = res.data.report
                this.samplingList = res.data.samplingList
                this.filePath = res.data.filePath
                this.fileName = res.data.fileName
                this.data_type = res.data.data_type
                this.ocr_log_id = 0
            }else{
                this.$message({
                    type: 'error',
                    duration: 0,
                    showClose: true,
                    message: res.msg
                });
            }
        },
        beforeUpload(file){
            const isLt2M = file.size / 1024 / 1024 < 10;
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过10MB!');
            }
            return isLt2M;
        },
        resetData(){
            this.data_type =0
            this.msgList = []
            this.fileList = []
            this.report = {work_type_int: 1}
            this.samplingList = []
            this.filePath = ''
            this.fileName = ''
            this.uuidList = []
            this.fileListBase64 = []
        },
        testImp(){
            ocrRecognitionPDF(this.upData.recognition_type).then(res=>{
                if(res.code == 1){
                    this.$msgs("请预览该报告数据");
                    this.report = res.data.report
                    this.samplingList = res.data.samplingList
                    this.filePath = res.data.filePath
                    this.fileName = res.data.fileName
                    this.data_type = res.data.data_type
                    this.ocr_log_id = 0
                } else {
                    this.$message({
                        type: 'error',
                        duration: 0,
                        showClose: true,
                        message: res.msg
                    });
                }
            })
        },
        saveData(deal_type, save_type){
            let list_str = JSON.stringify(this.samplingList)
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            ocrSaveReport(1,
                this.report.device_code,
                this.report.channel_no,
                this.report.begin_time,
                this.report.end_time,
                this.report.work_type,
                this.report.hole_code,
                this.report.segment_no,
                this.report.segment_length,
                this.report.segment_top,
                this.report.segment_bottom,
                this.report.pile_no,
                this.report.lift_hole_no,
                this.report.hole_height,
                this.report.order_index,
                this.report.water_ash,
                this.report.sand_ash,
                this.report.pressure_set,
                this.report.water_mud_proportion,
                this.report.sand_proportion,
                this.report.circle_type,
                this.report.water_pressure,
                this.report.groundwater_level,
                this.report.grout_volume,
                this.report.ash_volume,
                this.report.ash_volume_unit,
                this.report.sand_volume,
                this.report.grout_volume_throw,
                this.report.ash_volume_throw,
                this.report.piping_volume,
                this.report.piping_ash_volume,
                this.report.material1_total,
                this.report.material2_total,
                this.report.security_code,
                this.report.grout_duration,
                this.report.permeable_rate,
                this.report.construction_unit,
                this.report.monitor_unit,
                this.report.time_interval,
                list_str,
                this.filePath,
                this.fileName,
                deal_type,
                this.ocr_log_id,
                save_type
            ).then(res=>{
                loading.close()
                if(res.code == 1){
                    this.resetData()
                    if(save_type == 1){
                        this.$msgs("导入成功");
                    }else if(save_type ==2){
                        this.$msgs("暂存成功");
                    }
                } else if(res.code == 2){
                    this.$confirm('该灌浆孔的该段号的作业报告已经导入?', '提示', {
                        confirmButtonText: '存入异常列表',
                        cancelButtonText: '丢弃数据',
                        type: 'warning'
                    }).then(() => {
                        this.saveData(1, 1)
                    }).catch(() => {
                        this.resetData()
                    })
                }else {
                    this.$message({
                        type: 'error',
                        duration: 0,
                        showClose: true,
                        message: res.msg
                    });
                }
            })
        },
        workTypeChange(work_type) {
            if (work_type.indexOf("灌浆") < 0 && work_type.indexOf("冲洗") < 0 && work_type.indexOf("压水") < 0 && work_type.indexOf("封孔") < 0) {
                this.$message({
                    type: 'error',
                    duration: 0,
                    showClose: true,
                    message: "作业方式必须为‘灌浆’、‘冲洗’、‘压水’、‘封孔’的其中一种"
                });
            }
            if (work_type.indexOf("灌浆") >= 0) {
                this.report.work_type_int = 1;
            } else if (work_type.indexOf("冲洗") >= 0) {
                this.report.work_type_int = 2;
            } else if (work_type.indexOf("压水") >= 0) {
                this.report.work_type_int = 3;
            } else if (work_type.indexOf("复灌") >= 0) {
                this.report.work_type_int = 4;
            } else if (work_type.indexOf("封孔") >= 0) {
                this.report.work_type_int = 5;
            }
        },
        addRow(){
            let new_row = {
                sampling_time_str: '',
                title: '',
                remark: '',
                flow: 0,
                flow_out: 0,
                flow_in: 0,
                pressure_max: 0,
                pressure: 0,
                density: 0,
                water_ash_proportion: 0,
                sand_ash_proportion: 0,
                grout_volume: 0,
                ash_volume: 0,
                sand_volume: 0,
                lift: 0,
                permeable_rate: 0,
            }
            this.samplingList.push(new_row)
        },
        insertRow(index){
            let new_row = {
                sampling_time_str: '',
                title: '',
                remark: '',
                flow: 0,
                flow_out: 0,
                flow_in: 0,
                pressure_max: 0,
                pressure: 0,
                density: 0,
                water_ash_proportion: 0,
                sand_ash_proportion: 0,
                grout_volume: 0,
                ash_volume: 0,
                sand_volume: 0,
                lift: 0,
                permeable_rate: 0,
            }
            this.samplingList.splice(index+1, 0, new_row)
        },
        downRow(index){
            this.samplingList.splice(index, 1)
        },
        ocrLogList(type){
            if(type ==2){
                this.ocr_title = 'OCR暂存记录'
            }else if(type == 1){
                this.ocr_title = 'OCR识别记录'
            }
            this.save_type = type
            this.ocrlogshow = true
        },
        closeOcrLogDialog(){
            this.ocrlogshow = false
        },
        selectOcrLog(id){
            this.ocrlogshow = false
            this.resetData()
            ocrInfo(id).then(res=>{
                if(res.code == 1){
                    this.ocr_log_id = id
                    this.$msgs("请预览该报告数据");
                    this.report = res.data.report
                    this.samplingList = res.data.samplingList
                    this.filePath = res.data.filePath
                    this.fileName = res.data.fileName
                    this.data_type = 1
                }else {
                    this.$message({
                        type: 'error',
                        duration: 0,
                        showClose: true,
                        message: res.msg
                    });
                }
            })
        },
        takePictures(){
            // const loading = this.$loading({
            //     lock: true,
            //     text: '正在执行...',
            //     spinner: 'el-icon-loading',
            //     background: 'rgba(0, 0, 0, 0.7)'
            // });
            try {
                takePictures().then(res=>{
                    //loading.close()
                    if(res.code == 0){
                        let uuid = {
                            "uuid": res.images[0].uuid
                        }
                        this.uuidList.push(uuid)
                        this.fileListBase64.push('data:image/png;base64,'+res.images[0].base64)
                    }else{
                        this.$message({
                            type: 'error',
                            duration: 0,
                            showClose: true,
                            message: '调用扫描仪拍照失败'
                        });
                    }
                })
            } catch (error) {
                //loading.close()
                this.$message({
                    type: 'error',
                    duration: 0,
                    showClose: true,
                    message: '调用扫描仪拍照失败'
                });
            }
            
        },
        mergeToPdf(){
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            mergeToPdf(this.uuidList).then(res=>{
                loading.close()
                if(res.code == 0){
                    const loading = this.$loading({
                        lock: true,
                        text: '正在执行...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    const blob = this.base64ToBlob(res.base64, 'application/pdf');
                    const formData = new FormData();
                    formData.append('upFile', blob, 'filename.pdf');
                    formData.append('recognition_type', this.upData.recognition_type)
                    uploadBase64File(blob, this.upData.recognition_type).then(res=>{
                        loading.close()
                        if(res.code == 1){
                            this.$msgs("请预览该报告数据");
                            this.report = res.data.report
                            this.samplingList = res.data.samplingList
                            this.filePath = res.data.filePath
                            this.fileName = res.data.fileName
                            this.data_type = res.data.data_type
                            this.ocr_log_id = 0
                        }else{
                            this.$message({
                                type: 'error',
                                duration: 0,
                                showClose: true,
                                message: res.msg
                            });
                        }
                    })
                }else{
                    this.$message({
                        type: 'error',
                        duration: 0,
                        showClose: true,
                        message: '调用扫描仪拍照失败'
                    });
                }
            })
        },
        base64ToBlob(base64, mimeType) {
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], {type: mimeType});
        }

    }
};
</script>
<style lang="less" scoped>
    .upload-demo /deep/ .el-upload-dragger {
        width: 240px;
    }
    .el-table /deep/ .el-table__cell {
        padding: 10px 0;
    }
    .el-card /deep/ .el-card__header {
        padding: 10px 20px;
    }
    .btnBox {
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-around;
    }
    .radioBox {
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: row;
        align-items: flex-start;
    }
</style>